import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

interface SetupStepShellProps {
  children: ReactNode;
  className?: string;
  /**
   * Column width. Same centered shell for welcome and later steps so
   * the column never teleports horizontally between routes.
   */
  column?: 'default' | 'wide';
}

/**
 * Stable setup composition shell: graphite stage + centered column.
 * `my-auto` optically centers short steps; when content exceeds the
 * viewport, margins collapse and the step scrolls from the top.
 */
export function SetupStepShell({
  children,
  className,
  column = 'default',
}: SetupStepShellProps) {
  return (
    <main className="setup-step-shell flex min-h-dvh w-full flex-1 flex-col items-center">
      <div
        className={cn(
          'my-auto flex w-full flex-col gap-5',
          'px-4 pb-[max(3rem,calc(1.5rem+env(safe-area-inset-bottom,0px)))] pt-[max(5.5rem,calc(4.25rem+env(safe-area-inset-top,0px)))]',
          'sm:gap-6 sm:px-6 sm:pb-16 sm:pt-24',
          'md:px-8 md:py-24',
          column === 'wide' ? 'max-w-3xl' : 'max-w-2xl',
          className,
        )}
      >
        {children}
      </div>
    </main>
  );
}
